import { Observable } from 'rxjs/Observable'

import { Event } from '../../models'
import { EventApi, ReplyApi } from '../../apis'
import { Store } from '@ngrx/store'
import { AppState } from '../../reducers'
import { All } from '../../actions/event'

export abstract class EventService {
  protected abstract LoadEvents(resourceId: number, events: Event[]): All
  protected abstract AddEvent(event: Event, enabledChatgpt?:boolean): All
  protected abstract RemoveEvent(eventId: number): All
  protected abstract UpdateEvent(event: Event): All

  constructor(
    protected api: EventApi,
    protected replyApi: ReplyApi,
    protected store: Store<AppState>,
  ) { }

  index(resourceId: number): Observable<Event[]> {
    return this.api.index(resourceId)
  }

  all(resourceId: number, groupIds?: number[]): Observable<Event[]> {
    return this.api.all(resourceId, groupIds)
      .do((events: Event[]) => this.store.dispatch(this.LoadEvents(resourceId, events)))
  }

  group(resourceId: number): Observable<Event[]> {
    return this.api.group(resourceId)
      .do((events: Event[]) => this.store.dispatch(this.LoadEvents(resourceId, events)))
  }

  post(resourceId: number, kind: string): Observable<Event> {
    return this.api.post(resourceId, kind)
  }

  directPost(resourceId: number, payload: any): Observable<Event> {
    return this.api.directPost(resourceId, payload)
      .do(event => this.store.dispatch(this.AddEvent(event, payload['enable_chatgpt'])))
  }

  delete(resourceId: number, eventId: number): Observable<any> {
    return this.api.delete(resourceId, eventId)
      .do(() => this.store.dispatch(this.RemoveEvent(eventId)))
  }

  reply(eventId: number, payload: any): Observable<Event> {
    return this.replyApi.directPost(eventId, payload)
      .do(event => this.store.dispatch(this.UpdateEvent(event)))
  }

  delete_reply(eventId: number, replyId: number): Observable<Event> {
    return this.replyApi.delete(eventId, replyId)
      .do(event => this.store.dispatch(this.UpdateEvent(event)))
  }
}



// WEBPACK FOOTER //
// ./src/services/event/base.ts